function load_custom_style_interface(elm, popup) {
    elm.off('openTab.custom-style').on('openTab.custom-style', async function(event, link) {
        if (link !== 'custom-style') return;
        const tab = elm.find('.sub-screen-wrapper#custom-style');
        const companyId = tab.data('object-id');

        elm.isLoading(true);


        const cssEditorPlaceholder = tab.find('.css-code-placeholder');

        if (cssEditorPlaceholder.length) {
            // Initiate code editor first
            const editorTextarea = jQuery('<textarea class="code" name="css" id="css" cols="30" rows="10" data-mode="css" \>');
            cssEditorPlaceholder.replaceWith(editorTextarea);
            editorTextarea.customTextarea();

            const loadCheck = (onLoad) => {
                if (elm.find('.ace_content').length === 0) {
                    setTimeout(() => loadCheck(onLoad), 100);
                } else {
                    onLoad();
                }
            }
            await new Promise((resolve) => {
                loadCheck(resolve);
            });
        }

        const editor = elm.find('.ace_editor')[0].env.editor;

        const styleSettings = await jQuery.getJSON(`/companies/${companyId}/getStyleSettings`);


        // Remove the welcome picture toggle if css is empty
        const showImageRow = elm.find('input[name="show_bing_image"]').closest('.row');
        editor.session.on("change", function () {
            const css = editor.getValue();
            showImageRow.toggle(css !== '');
        });



        if (Object.keys(styleSettings).includes('css')) {
            editor.setValue(styleSettings.css);
            showImageRow.toggle(styleSettings.css !== '');
        } else {
            editor.setValue('');
            showImageRow.hide();
        }

        elm.find('input[name="show_bing_image"]').prop('checked',
            Object.keys(styleSettings).includes('show_bing_image') ?
                styleSettings.show_bing_image === 1 :
                false);

        elm.find('form').ajaxFormSubmit((data) => {
            if (document.closeWindow) {
                _.unset(document, 'closeWindow');
                popup.close();
            } else {
                elm.trigger('openTab', ['custom-style']);
            }
        })

        elm.doneLoading();
    });
}
